import { isAxiosError } from "axios";

import { STEP_UP_REQUIRED_ERROR } from "./constants";

/**
 * True for a home-health-api `403 STEP_UP_REQUIRED` response. These are never transient:
 * the axios interceptor owns the re-auth + retry, so react-query must not retry them
 * (retrying re-triggers the 403 and re-opens the modal after "Cancel"), and the global
 * error handler must not toast them (a declined prompt would otherwise storm one snackbar
 * per blocked query — the modal itself is the UX).
 */
export function isStepUpRequiredError(error: unknown): boolean {
  if (!isAxiosError(error) || error.response?.status !== 403) {
    return false;
  }

  const body = error.response.data as { errors?: Array<{ code?: string }> } | undefined;
  const errors = body?.errors;
  return (
    Array.isArray(errors) &&
    errors.some((jsonApiError) => jsonApiError.code === STEP_UP_REQUIRED_ERROR)
  );
}
